.center_div{margin-top:10px;margin-left:50px;width:70%}
/*# sourceMappingURL=verification.component-CHLMJYDV.css.map */
